import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import TextField from "app/components/UI/TextField";
import classes from "./AccountForm.module.css";

export const AccountFormName = ({ translate, onFieldChange, formValue }) =>
  <Flex direction="row" space="around" className={classes.accountForm__fieldset} wrap>
    <TextField
      className={classes.accountForm__field}
      floatingLabelText={translate("Prénom")}
      hintText={translate("Ajoutez ici votre prénom")}
      onChange={onFieldChange("givenName")}
      value={formValue.givenName || ""}
    />
    <TextField
      className={classes.accountForm__field}
      floatingLabelText={translate("Nom")}
      hintText={translate("Ajoutez ici votre nom de famille")}
      onChange={onFieldChange("familyName")}
      value={formValue.familyName || ""}
    />
  </Flex>;

AccountFormName.propTypes = {
  translate: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  formValue: PropTypes.object.isRequired
};

export default AccountFormName;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountForm/AccountFormName.js